import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { AUTH_ENABLED } from './auth/msalConfig';
import { initializeMsal } from './auth/msalInstance';
import { compensarLienzoCorto } from './lib/lienzoCorto';

async function bootstrap() {
  // Antes de pintar: si iOS entregó un lienzo más corto que la pantalla, la
  // reserva del indicador de inicio ya quedó afuera y no se paga de nuevo
  // adentro. En la compu y en una instalación sana no hace nada.
  compensarLienzoCorto();

  // Initialize MSAL (no-op if AUTH_ENABLED is false).
  // Must complete before render so that getAllAccounts() works correctly during the first paint.
  const msalInstance = await initializeMsal();

  const root = ReactDOM.createRoot(document.getElementById('root')!);

  if (AUTH_ENABLED && msalInstance) {
    // Lazy-import to avoid loading MSAL React in the bundle when auth is disabled.
    const [{ MsalProvider }, { AuthGate }] = await Promise.all([
      import('@azure/msal-react'),
      import('./auth/AuthGate'),
    ]);

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthGate>
            <App />
          </AuthGate>
        </MsalProvider>
      </React.StrictMode>
    );
  } else {
    // DevMode: render the app without any auth wrappers.
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

bootstrap().catch((err) => {
  console.error('App bootstrap failed:', err);
  document.getElementById('root')!.innerHTML =
    '<div style="padding:2rem;font-family:system-ui">App failed to initialize. See console.</div>';
});